<style>
.mb30{margin-bottom: 30px;}
</style>
<template id="personal_center">
	<div>
		<div class="col-md-12 pr-0 pl-0 centre_sm_none">
			<div class="accountManage">
				<p class="account_manage_title">Member center</p>

				<div class="nano video_breviary">
					<div class="nano-content">
					<div class="card p-4 border-top-0 border-right-0 border-left-0 border-light" v-if="user.level > 1">
						<div class="card-body row m-0 p-0">
						    <div class="float-left col-md-auto" style="line-height: 107px;padding-left:0">
					    		<img class="figure-img img-fluid rounded mb-0" alt="Member of basic edition" v-if="user.level == 2" style="width:335px;height:107px;" src="../../../assets/images/silkRoadBase/vip/1.png" />
					    		<img class="figure-img img-fluid rounded mb-0" alt="Member of think-tank edition" v-if="user.level == 3" style="width:335px;height:107px;" src="../../../assets/images/silkRoadBase/vip/2.png" />
					    		<img class="figure-img img-fluid rounded mb-0" alt="Member of advanced edition" v-if="user.level == 4" style="width:335px;height:107px;" src="../../../assets/images/silkRoadBase/vip/3.png" />
					    		<img class="figure-img img-fluid rounded mb-0" alt="Member of advanced edition" v-if="user.level == 5" style="width:335px;height:107px;" src="../../../assets/images/silkRoadBase/vip/4.png" />
					    		<img class="figure-img img-fluid rounded mb-0" alt="Member of advanced edition" v-if="user.level == 6" style="width:335px;height:107px;" src="../../../assets/images/silkRoadBase/vip/5.png" />
					    		<img class="figure-img img-fluid rounded mb-0" alt="Member of advanced edition" v-if="user.level == 7" style="width:335px;height:107px;" src="../../../assets/images/silkRoadBase/vip/6.png" />
					    	</div>
					    	<div class="float-left col-md-auto">
					    		<div class="text-center bg-light h-100 pt-2 pb-2 pl-5 pr-5" style="line-height: 35px;">
					    			<p class="f15">VIP expiration time</p>
					    			<p class="f24 mb-0">{{user.expire}}</p>
					    		</div>
					    	</div>
					    	<div class="col"></div>
						</div>
					</div>
					<div class="card border-0">
						<div class="card-body">
							<div>More membership benefits</div>
							<div class="row mt-4">
								<div class=" col-sm-12 col-250 mb30" >
									<div class="card">
										<div class="card-header border-bottom-0 p-0">
										   <img src="../../../assets/images/silkRoadBase/vip/1.png" class="card-img-top" alt="">
										</div>

										<div class="card-body">
										   <h5 class="card-title text-center f18"></h5>
										   <p class="card-text f14 text-center text-black-50">Contact us to learn more</p>
										   <button type="button" class="btn btn-darks w-100" style="border-radius:0px;padding:.5rem .75rem" @click="maskPop(1)">Join now</button>
										   <p class="mt-4 mb-2">Note：</p>
										   <ul class="pl-0 myfont">
										   		<li class="pt-1 pb-1"><i class="fa fa-check mr-2"></i>No limitation for URLs; permission for an active computer via a single account.</li>
										   </ul>
										</div>
									</div>
								</div>
								<div class=" col-sm-12 col-250 mb30" >
									<div class="card">
										<div class="card-header border-bottom-0 p-0">
										   <img src="../../../assets/images/silkRoadBase/vip/2.png" class="card-img-top" alt="">
										</div>

										<div class="card-body">
										   <h5 class="card-title text-center f18"></h5>
										   <p class="card-text f14 text-center text-black-50">Contact us to learn more</p>
										   <button type="button" class="btn btn-darks w-100" style="border-radius:0px;padding:.5rem .75rem" @click="maskPop(2)">Join now</button>
										   <p class="mt-4 mb-2">Note：</p>
										   <ul class="pl-0 myfont">
										   		<li class="pt-1 pb-1"><i class="fa fa-check mr-2"></i>No limitation for URLs; permission for an active computer via a single account.</li>
										   </ul>
										</div>
									</div>
								</div>
								<div class=" col-sm-12 col-250 mb30" >
									<div class="card">
										<div class="card-header border-bottom-0 p-0">
										   <img src="../../../assets/images/silkRoadBase/vip/3.png" class="card-img-top" alt="">
										</div>

										<div class="card-body">
										   <h5 class="card-title text-center f18"></h5>
										   <p class="card-text f14 text-center text-black-50">Contact us to learn more</p>
										   <button type="button" class="btn btn-darks w-100" style="border-radius:0px;padding:.5rem .75rem" @click="maskPop(3)">Join now</button>
										   <p class="mt-4 mb-2">Note：</p>
										   <ul class="pl-0 myfont">
										   		<li class="pt-1 pb-1"><i class="fa fa-check mr-2"></i>No limitation for URLs; permission for an active computer via a single account.</li>
										   </ul>
										</div>
									</div>
								</div>
								<div class=" col-sm-12 col-250 mb30" >
									<div class="card">
										<div class="card-header border-bottom-0 p-0">
										   <img src="../../../assets/images/silkRoadBase/vip/4.png" class="card-img-top" alt="">
										</div>

										<div class="card-body">
										   <h5 class="card-title text-center f18"></h5>
										   <p class="card-text f14 text-center text-black-50">Contact us to learn more</p>
										   <button type="button" class="btn btn-darks w-100" style="border-radius:0px;padding:.5rem .75rem" @click="maskPop(4)">Join now</button>
										   <p class="mt-4 mb-2">Note：</p>
										   <ul class="pl-0 myfont">
										   		<li class="pt-1 pb-1"><i class="fa fa-check mr-2"></i>Logon to Xinhua Silk Road Database; permission for an active computer via a single account.</li>
										   </ul>
										</div>
									</div>
								</div>
								<div class=" col-sm-12 col-250 mb30" >
									<div class="card">
										<div class="card-header border-bottom-0 p-0">
										   <img src="../../../assets/images/silkRoadBase/vip/5.png" class="card-img-top" alt="">
										</div>

										<div class="card-body">
										   <h5 class="card-title text-center f18"></h5>
										   <p class="card-text f14 text-center text-black-50">Contact us to learn more</p>
										   <button type="button" class="btn btn-darks w-100" style="border-radius:0px;padding:.5rem .75rem" @click="maskPop(5)">Join now</button>
										   <p class="mt-4 mb-2">Note：</p>
										   <ul class="pl-0 myfont">
										   		<li class="pt-1 pb-1"><i class="fa fa-check mr-2"></i>Logon to Xinhua Silk Road Database; permission for an active computer via a single account.</li>
										   </ul>
										</div>
									</div>
								</div>
								<div class=" col-sm-12 col-250 mb30" >
									<div class="card">
										<div class="card-header border-bottom-0 p-0">
										   <img src="../../../assets/images/silkRoadBase/vip/6.png" class="card-img-top" alt="">
										</div>

										<div class="card-body">
										   <h5 class="card-title text-center f18"></h5>
										   <p class="card-text f14 text-center text-black-50">Contact us to learn more</p>
										   <button type="button" class="btn btn-darks w-100" style="border-radius:0px;padding:.5rem .75rem" @click="maskPop(6)">Join now</button>
										   <p class="mt-4 mb-2">Note：</p>
										   <ul class="pl-0 myfont">
										   		<li class="pt-1 pb-1"><i class="fa fa-check mr-2"></i>Unlimited accesses; permission for an active computer via a single account.</li>
										   </ul>
										</div>
									</div>
								</div>


							</div>
						</div>
					</div>
					</div>
				</div>
			</div>
		</div>
        <div class = "bg-model" v-show="maskShow" >
            　　<div class = 'maskContent'>

                    <div class="maskHeeard">
                        <span>Contact us for membership</span>
                        <img  src="../../../assets/images/silkRoadBase/closes.png" alt="" @click.stop.prevent="maskShow=false">
                    </div>
            <div class="contentInner">
                    <div class="maskMid">
                        <img style="width: 250px;" :src="imgLevel" alt="">
                    </div>
                     <p id="maskTT">Contact us</p>
                    <div class="maskFoot">
                        <p>Beijing(Head Office)</p>
                        <p>Address: NO. A-1，Xuanwumenwai Street，Xicheng District，Beijing 100052 China</p>
                        <p>Tel:86-10-6307 6014</p>
                        <p>Email: silkroadweekly@xinhua.org</p>
                    </div>
            　　</div>
        </div>
        </div>
	</div>
</template>
<script>
	export default({
		name: 'menberCenter',
		data: function() {
			const vip1 = 'static/images/vip/1.png';
			const vip2 = 'static/images/vip/2.png';
			const vip3 = 'static/images/vip/3.png';
			const vip4 = 'static/images/vip/4.png';
			const vip5 = 'static/images/vip/5.png';
			const vip6 = 'static/images/vip/6.png';
			return {
				vip1,
				vip2,
				vip3,
				vip4,
				vip5,
				vip6,
				maskShow:false,
                imgLevel:vip1,
                user:{}
			}
		},
		created: function() {
            let self = this;
            // 获取用户信息
            this.$axios.post('/api/pc/getmember').then(data => {
                if (data.data.state) {
                    self.user=data.data.data;
                }
            })

		},
		mounted() {
			this.load();
			this.closeModel()
		},
		methods: {
            maskPop(type){
				if (type == 1) {
					this.imgLevel = this.vip1;
				} else if (type == 2) {
					this.imgLevel = this.vip2;
				} else if (type == 3) {
					this.imgLevel = this.vip3;
				} else if (type == 4) {
					this.imgLevel = this.vip4;
				} else if (type == 5) {
					this.imgLevel = this.vip5;
				} else if (type == 6) {
					this.imgLevel = this.vip6;
				} 
                this.maskShow=true;
            },
            closeModel(){
                let that=this;
                $(document).mousedown(function(e){
                    if(that.maskShow==true){
                        if($(e.target).hasClass("bg-model")){
                            that.maskShow=false;
                        }
                    }
                })
            },

		},
		computed: {

		}

	})
</script>
